import type {
  Flow_AbstractComponent,
  Flow_Diff,
  Flow_ComponentProps,
  Flow_ObjMap,
} from 'src/types/flow-to-typescript-codemod';
import {
  type CUSTOM_FIELDS,
  type CUSTOM_FORM_TYPE,
  type CustomForm as CustomFormType,
} from 'src/types/crm';

import * as React from 'react';
import {useApi} from 'src/hooks/useApi';
import CustomForm from 'src/components/crm/jobs/crud/job-details/custom-form/custom-form';


type CustomFilterProps = {
  initialValues: CUSTOM_FIELDS[];
  onChange: (data: {
    values: Array<{
      fieldId: number;
      value: string | null;
    }>;
    isValid: boolean;
    errors: Array<{
      fieldId: number;
      error: string;
    }>;
    formId?: string;
  }) => void;
  customFormList: Array<CustomFormType>;
  isLoadingCustomForm: boolean;
};

export const CustomFilter: Flow_AbstractComponent<CustomFilterProps, unknown> =
  React.memo<CustomFilterProps>(
    ({
      onChange,
      initialValues,
      customFormList,
      isLoadingCustomForm,
    }: CustomFilterProps) => {
      const handleOnChange = (
        values: Array<{
          fieldId: number;
          value: string | null;
          fieldType: string;
        }>,
        isValid: boolean,
        errors: Array<{
          fieldId: number;
          error: string;
        }>,
      ) => {
        onChange({values, isValid, errors, formId: customFormList?.[0]?.id});
      };

      return (
        <CustomForm
          fields={Array.isArray(customFormList) ? customFormList : null}
          // @ts-expect-error - TS2769 - No overload matches this call.
          onChange={handleOnChange}
          initialValues={initialValues}
          viewType="1"
          showFormTypes={[]}
          checkCondition={false}
        />
      );
    },
  );
